import { getAuthState } from "../../assets/scripts/login-util";
import { axiosPost, axiosGet, axiosDelete } from "./axiosFunctions";

const getMatMasterAllUrl                = '/api/admin/mat/getMatMasterAll';
const postMatMasterUrl                  = '/api/admin/mat/postMatMaster';

const getMatTimeMasterAllUrl            = '/api/admin/mat/getMatTimeMasterAll';
const postMatTimeMasterUrl              = '/api/admin/mat/postMatTimeMaster';

const postMatTemplateUrl                = '/api/admin/mat/postMatTemplate';
const getMatTemplateByMasterIDUrl       = (id) => `/api/admin/mat/getMatTemplateByMasterID/${id}`;
const deleteMatTemplateUrl              = '/api/admin/mat/deleteMatTemplate';

const getMatBookUrl                     = '/api/admin/mat/getMatBook';
const postMatTimeBlockUrl               = '/api/admin/mat/postMatTimeBlock';  
const postMatBookUrl                    = '/api/admin/mat/postMatBook';
const postMatBookOfflineUrl             = '/api/admin/mat/postMatBookOffline';
const deleteMatTimeBlockUrl             = (id) => `/api/admin/mat/deleteMatTimeBlock/${id}`;  
const deleteMatBookUrl                  = (matBookID) => `/api/admin/mat/deleteMatBook/${matBookID}`;  
const getMatCancellationSheetUrl        = (fDate, tDate) => `/api/admin/mat/getMatCancellationSheet/${fDate}/${tDate}`;

const getMatPublishPageDataUrl          = '/api/admin/mat/getMatPublishPageData';    
const postMatPublishUrl                 = '/api/admin/mat/postMatPublish';    
const getPublishMasterDataUrl           = '/api/admin/mat/getPublishMasterData';    
const getRangeUserAllUrl                = '/api/admin/mat/getRangeUserAll';
const getRangeMembershipUserTypesUrl    = '/api/admin/mat/getRangeMembershipUserTypes';
const getUsersByUserTypeIDUrl           = (UserTypeID) => `/api/admin/mat/getUsersByUserTypeID/${UserTypeID}`;
const postRangeUserSubscriptionUrl      = '/api/admin/mat/postRangeUserSubscription';

const getExistingSubscriptionChargesByIDUrl       = (ID) => `/api/admin/mat/getExistingSubscriptionChargesBySubID/${ID}`;
const getGreenFeeCalendarAllUrl                   =         '/api/admin/mat/getRangeFeeCalendarAll';
const postRangeFeeCalendarUrl                     =         '/api/admin/mat/postRangeFeeCalendar';
const getRangeFeeMasterByCalenderIDUrl            = (calendarID) => `/api/admin/mat/getRangeFeeMasterByCalenderID/${calendarID}`;
const postRangeFeeMasterUrl                       = '/api/admin/mat/postRangeFeeMaster';
const getUserTypesUrl                             = '/api/admin/mat/getUserTypes';
const getActiveGuestsUrl                          = '/api/admin/mat/getActiveGuests';
const getBucketsUrl                               = '/api/admin/mat/getBuckets';
const getActiveRangeFeeMasterUrl                  = (currentDate) => `/api/admin/mat/getActiveRangeFeeMaster/${currentDate}`;

export const deleteMatBook = async (matBookID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(
        deleteMatBookUrl(matBookID),
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getMatCancellationSheet = async (fDate, tDate) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
  
    const response = await axiosGet(
        getMatCancellationSheetUrl(fDate, tDate),
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getMatMasterAll = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatMasterAllUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postMatMaster= async(matMaster)=>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatMasterUrl, { matMaster }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMatTimeMasterAll = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatTimeMasterAllUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postTimeMatMaster= async(matMaster)=>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatTimeMasterUrl, { matMaster }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postMatTemplate= async(matTemplate)=>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatTemplateUrl, { matTemplate }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const deleteMatTemplate = async(templateId) => {
    const token = getAuthState('token');
    if(!token) setTimeout(() => { return }, 2000);

    const response = await axiosDelete( `${deleteMatTemplateUrl}/${templateId}`, { headers: { auth_token: `bearer ${token}` } });
    return response;
}

export const getMatTemplateByMasterID = async(id) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatTemplateByMasterIDUrl(id), { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMatBook = async (matBookDetails) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( getMatBookUrl, {matBookDetails}, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postMatTimeBlock = async(books, date) =>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatTimeBlockUrl, { books, date }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const deleteMatTimeBlock = async (id) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosDelete(
        deleteMatTimeBlockUrl(id),
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const postMatBook = async(matBook)=>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatBookUrl, { matBook }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postMatBookOffline = async(matBook)=>{
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosPost( postMatBookOfflineUrl, { matBook }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getMatPublishPageData = async() => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getMatPublishPageDataUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postMatPublish = async(data) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postMatPublishUrl, {...data }, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getPublishMasterData = async(masterId) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( `${getPublishMasterDataUrl}/${masterId}`, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getRangeUserAll = async () => {
  const token = getAuthState('token');
  if (!token) setTimeout(() => { return }, 2000);

  const response = await axiosGet(
    getRangeUserAllUrl,
    { headers: { auth_token: `bearer ${token}` } }
  );
  return response;
};

export const fetchRangeUserTypes = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(
        getRangeMembershipUserTypesUrl,
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const fetchUsersByUserTypeID = async (typeID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet(
        getUsersByUserTypeIDUrl(typeID),
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const addUserRangeSubscription = async (userData) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);

    const response = await axiosPost(postRangeUserSubscriptionUrl, {userData}, { headers: { auth_token: `bearer ${token}` } } );
    return response;
};

export const getExistingSubscriptionChargesByID = async (ID) => {
  const token = getAuthState('token');
  if (!token) setTimeout(() => { return }, 2000);

  const response = await axiosGet(
    getExistingSubscriptionChargesByIDUrl(ID),
    { headers: { auth_token: `bearer ${token}` } }
  );
  return response;
};

export const getRangeFeeCalendarAll = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getGreenFeeCalendarAllUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const postRangeFeeCalendar = async (calendar) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost( postRangeFeeCalendarUrl, { calendar } , { headers: { auth_token: `bearer ${token}` } } );
    return response;
}

export const getRangeFeeMasterByCalenderID = async (calendarID) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getRangeFeeMasterByCalenderIDUrl(calendarID), { headers: { auth_token: `bearer ${token}` } } );
    return response;
};

export const postRangeFeeMaster = async (rangeFeeMasterList) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosPost(
        postRangeFeeMasterUrl,
      { rangeFeeMasterList },
      { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const getUserTypes = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getUserTypesUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
};

export const getActiveGuests = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getActiveGuestsUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
};

export const getBuckets = async () => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getBucketsUrl, { headers: { auth_token: `bearer ${token}` } } );
    return response;
};

export const getActiveRangeFeeMaster = async (currentDate) => {
    const token = getAuthState('token');
    if (!token) setTimeout(() => { return }, 2000);
    
    const response = await axiosGet( getActiveRangeFeeMasterUrl(currentDate), { headers: { auth_token: `bearer ${token}` } } );
    return response;
};